module.exports = __webpack_public_path__ + "img/dividendContainer1Model.5f5b9eb4.png";